import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['days', 'totalpatients', 'totaldebtor', 'btncontinue']

  connect() {
    this.totalPatients()
  }

  totalPatients() {
    let debtorDays;
    debtorDays = this.daysTarget.value
    this.btncontinueTarget.disabled = false
    if (! debtorDays) {
      this.btncontinueTarget.disabled = true
    }
    if (debtorDays) {
      debtorDays = JSON.parse(debtorDays)
      fetch(document.getElementById('campaign-statistics').dataset.statisticsUrl + debtorDays.debtor_days)
        .then(response => response.json())
        .then(html => {
          this.setDivValue(html)
        })
    } else {
      this.setDivValue('')
    }
  }

  setDivValue(value) {
    let contentdiv
    contentdiv = this.totalpatientsTarget.innerHTML
    if (value) {
      if (value.length > 0) {
        this.totalpatientsTarget.innerHTML = "Estimativa de envio após ativação: <strong>" + value.length + " mensagens</strong>"
      }
      this.totaldebtorTarget.innerHTML = "Total de envio nas próximas horas: <strong>" + value.length + " mensagens</strong>"
      this.totaldebtorTarget.classList.remove('tw-hidden')
      var el = document.querySelector('#btn-submit-form-capaign')
    } else {
      this.totalpatientsTarget.innerHTML = ""
    }
  }
}